import React from 'react';

import CtaLink from 'components/essentials/Cta/CtaLink';
import CategoryPage from '../CategoryPage';

const CollectionPage = () => (
  <CategoryPage
    sidebarHeader={
      <div className="w-[70%] mb-4 p-2 bg-brand-lightest">
        <CtaLink
          to="/collections"
          styling="link"
          size="sm"
          hasArrow={false}
          color="brand"
          spacing="sm"
          className="flex"
        >
          {`<  All collections`}
        </CtaLink>
      </div>
    }
  />
);

export default CollectionPage;
